export default __webpack_public_path__ + "static/media/MutaAici.0b708f4d.svg";